module.exports = __webpack_public_path__ + "img/pic_subject_math.b86539e1.png";